import * as React from 'react';
import { isEmpty } from 'lodash';

import { getFormattedPercentageRate } from 'utils/formatters';

import './proposal-tile-top-stats.scss';

type Stat = {
  label: string,
  percentage: number,
  title?: string
};

type Props = {
  title: string,
  stats: Array<Stat>
};

const ProposalTopStats: React.FunctionComponent<Props> = ({ title, stats }: Props) => {
  if (isEmpty(stats)) {
    return null;
  }

  return (
    <section className="proposal-tile-top-stats">
      <div className="proposal-tile-top-stats__title">
        {title}
      </div>
      <div className="proposal-tile-top-stats__stats">
        {
          [1, 2, 3].map((_, index) => {
            const label = stats[index]?.label ?? '\u00A0';
            const percentage = stats[index]?.percentage;
            const entryTitle = stats[index]?.title;

            const value = percentage !== undefined
              ? getFormattedPercentageRate(percentage / 100)
              : '';

            return (
              <div
                key={index}
                title={entryTitle}
                className="proposal-tile-top-stats__single-stat"
              >
                <div className="proposal-tile-top-stats__stat-label">
                  {label}
                </div>
                <div className="proposal-tile-top-stats__stat-value">
                  {value}
                </div>
              </div>
            );
          })
        }
      </div>
    </section>
  );
};

export default ProposalTopStats;
